import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./CreateNewDepartment.css";

export default function CreateNewDepartment() {
  const [form, setForm] = useState({
    name: "",
    username: "",
    password: "",
    email: "",
    role: "",
    status: "Disable",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", form);
  };

  return (
    <div className="create-staff-container">
      {/* Breadcrumb */}
      <div className="breadcrumb">
        <NavLink to="/">Home</NavLink> /{" "}
        <NavLink to="/manage-staff">Manage Roles</NavLink> / Create New
      </div>

      {/* Header */}
      <div className="header-row">
        <h2 className="page-title">Create New Department</h2>
        <button className="btn-view-all">👁 View All</button>
      </div>

      {/* Form Card */}
      <div className="form-card">
        <form onSubmit={handleSubmit}>
          <div className="form-grid">
            <div className="form-group">
              <label>Name</label>
              <input
                type="text"
                name="username"
                value={form.username}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Enable/Disable</label>
              <select
                name="status"
                value={form.status}
                onChange={handleChange}
              >
                <option value="Disable">Disable</option>
                <option value="Enable">Enable</option>
              </select>
            </div>
          </div>

          {/* Submit Button */}
          <div className="form-actions">
            <button type="submit" className="btn-submit">
              Submit
            </button>
          </div>
        </form>
      </div>

      {/* Footer */}
      <div className="footer">
        <p>
          Copyright © 2025 <span className="brand">Ample Markets</span>. All
          rights reserved.
        </p>
        <p className="version">Version 2.0</p>
      </div>
    </div>
  );
}
